import { useContext, useState } from 'react';
import { AuthContext } from 'context';
import { DICTONARY } from 'const/Dictonary';
import { ObtieneUltimaTransaccion } from 'views/Transaccion/utils';
import { useHistory } from 'react-router-dom';
import serviceRSD from 'services/residuos';
import { AlertaError, AlertaExito } from 'utils/Alertas';
import { PERMISOS } from 'const/Permisos';
export const useLogicaNegocio = () => {
  const {
    perfiles: { isSuperAdmin, isAdmin },
    logeduser,
    sucursalNoAdministrada,
    isTienePermisos
  } = useContext(AuthContext);
  const history = useHistory();
  const [listaSucursalesUsuarioLogueado] = useState([]);
  const [listaSalasChat, setListaSalasChat] = useState([]);
  const [transaccionSelected, setTransaccionSelected] = useState(false);
  const [dataEmpresasFiltradas, setDataEmpresasFiltradas] = useState([]);
  // Data Login
  const { perfiles } = logeduser;
  // Modal
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setTransaccionSelected(false);
    setOpenModal(false);
  };

  // LÓGICA PARA IR A LA SALA DE CHAT
  const handleClickSalaChat = codigoTransaccion => {
    if (!codigoTransaccion) return;
    if (!listaSalasChat) return;

    const salaChat = listaSalasChat.find(
      sala => sala.transaccion?.codigoTransaccion === codigoTransaccion
    );

    if (!salaChat) {
      AlertaError(
        'Esta transacción no tiene una sala de reunión asignada. Debe solicitar la sala primero.'
      );
      return;
    }

    history.push('/chat/' + salaChat.codigoSalaChat);
  };

  // LÓGICA PARA APROBAR RECEPTORES  o DEMANDANTES(deprecado) y ASESOR CIRCULARIDAD
  const handleClickTerminarYAprobarReceptor = (event, transaccion, rol) => {
    const { transaccionEstado, codigoTransaccion } = transaccion;

    let ultimaTransaccion = ObtieneUltimaTransaccion(
      codigoTransaccion,
      transaccionEstado
    );

    setTransaccionSelected({
      nombreEstado: ultimaTransaccion.nombreEstado,
      codigoEstado: ultimaTransaccion.codigoEstado,
      ...transaccion
    });

    handleOpenModal();
  };

  // LÓGICA PARA APROBAR GENERADORES u OFERENTES(deprecado) y ASESOR CIRCULARIDAD
  const handleClickTerminarYAprobarGenerador = (event, transaccion, rol) => {
    const { codigoTransaccion, transaccionEstado, sucursalTransaccion } =
      transaccion;

    let ultimaTrasaccion = ObtieneUltimaTransaccion(
      codigoTransaccion,
      transaccionEstado
    );

    setTransaccionSelected({
      nombreEstado: ultimaTrasaccion.nombreEstado,
      codigoEstado: ultimaTrasaccion.codigoEstado,
      ...transaccion
    });

    const dataFormateada = {
      transaccionEstado: [
        {
          estado: {
            codigoEstado: DICTONARY.ESTADOS_TRANSACCION[4].CODIGO // APROBADO POR GENERADOR
          }
        }
      ]
    };
    try {
      serviceRSD
        .cerrarTransacciones(dataFormateada, codigoTransaccion)
        .then(result => {
          //SI TIENE EXITO LA TRANSACCION, ENVIAR A VISTA RESUMEN DE TRANSACCION
          let stateTemp = {
            codigoTransaccion: codigoTransaccion
          };
          history.push({
            pathname: '/transacciones/resumen',
            state: stateTemp
          });
        });
    } catch (error) {
      console.log('ERROR AL CERRAR LA TRANSACCION:');
      console.error(error);
      AlertaError(
        'Ha ocurrido un error al tratar de cerrar la transacción. Por favor inténtelo más tarde.'
      );
    }
  };

  // LÓGICA PARA RECHAZAR POR GENERADOR y RECEPTOR y ASESOR CIRCULARIDAD
  const handleClickTerminarYRechazar = async (event, transaccion, rol) => {
    try {
      const { codigoTransaccion } = transaccion;

      const dataFormateada = {
        transaccionEstado: [
          {
            estado: {
              codigoEstado:
                rol === DICTONARY.ROL.RECEPTOR.NOMBRE
                  ? DICTONARY.ESTADOS_TRANSACCION[3].CODIGO // RECHAZADO POR RECEPTOR
                  : DICTONARY.ESTADOS_TRANSACCION[5].CODIGO // RECHAZADO POR GENERADOR
            }
          }
        ]
      };
      // console.log('dataFormateada >> ', dataFormateada);
      serviceRSD
        .cerrarTransacciones(dataFormateada, codigoTransaccion)
        .then(result => {
          //SI TIENE EXITO LA TRANSACCION, ENVIAR A VISTA RESUMEN DE TRANSACCION
          // console.log('RESULT >> ', result);
          let stateTemp = {
            codigoTransaccion: codigoTransaccion
          };
          history.push({
            pathname: '/transacciones/resumen',
            state: stateTemp
          });
        });
    } catch (error) {
      console.log('ERROR AL CERRAR LA TRANSACCION:');
      console.error(error);
      AlertaError(
        'Ha ocurrido un error al tratar de cerrar la transacción. Por favor inténtelo más tarde.'
      );
    }
  };

  // UTILIZADO POR GENERADOR , RECEPTOR  y ASESOR CIRCULARIDAD
  const handleClickResumenTransaccion = codigoTransaccion => {
    let stateTemp = {
      codigoTransaccion: codigoTransaccion,
      tipo: 'resumen'
    };
    history.push({
      pathname: `/transacciones/resumen`,
      state: stateTemp
    });
  };

  // UTILIZADO POR GENERADOR , RECEPTOR  y ASESOR CIRCULARIDAD
  const handleClickGuardarResiduoDeclarado = async codigoTransaccion => {
    try {
      serviceRSD
        .declararTransaccion({ codigoTransaccion: codigoTransaccion })
        .then(result => {
          if (result.status === 200) {
            AlertaExito(
              `La transacción ha sido guardada como residuo declarado exitosamente. Código residuo declarado: ${result.data?.codigoResiduoDeclarado}`
            );
          }
        })
        .catch(error => {
          AlertaError(
            'Ha ocurrido un error al tratar de guardar la transacción como residuo declarado.'
          );
          console.error(error);
        });
    } catch (error) {
      console.log('ERROR AL GUARDAR RESIDUO DECLARADO:');
      console.error(error);
      AlertaError(
        'Ha ocurrido un error al tratar de guardar la transacción como residuo declarado. Por favor inténtelo más tarde.'
      );
    }
  };

  // DETERMINAR EL ROL QUE TIENE EL USUARIO EN LA TRANSACCIÓN
  const determinarRolEnTransaccion = transaccion => {
    if (!transaccion || !logeduser || !listaSucursalesUsuarioLogueado) return;
    try {
      let codigoSucursalUsuarioLogueado = isSuperAdmin
        ? 0
        : isTienePermisos(PERMISOS.administracionSucursales)
        ? perfiles[0].codigoPerfil
        : sucursalNoAdministrada.sucursal.codigoSucursal; // TODO: verificar DEPRECADA : --> sucursalNoAdministrada.sucursal.codigoSucursal
      const roles = DICTONARY.ROLES;

      let sucursales = {};

      roles.forEach(rol => {
        sucursales[rol] = transaccion.sucursalTransaccion.find(
          sucursal => sucursal.nombreRol === rol
        );
      });

      // EN PRIMER LUGAR SE REVISA POR SUCURSAL
      const esDemandante =
        sucursales.receptor &&
        sucursales.receptor.sucursal.codigoSucursal ===
          codigoSucursalUsuarioLogueado;
      const esOferente =
        sucursales.generador &&
        sucursales.generador.sucursal.codigoSucursal ===
          codigoSucursalUsuarioLogueado;

      const esGestor =
        sucursales.gestor &&
        sucursales.gestor.sucursal.codigoSucursal ===
          codigoSucursalUsuarioLogueado;
      const esAsesor =
        sucursales.asesor &&
        sucursales.asesor.sucursal.codigoSucursal ===
          codigoSucursalUsuarioLogueado;
      const esTransportista =
        sucursales.transportista &&
        sucursales.transportista.sucursal.codigoSucursal ===
          codigoSucursalUsuarioLogueado;

      if (esDemandante) {
        return DICTONARY.ROL.RECEPTOR.NOMBRE;
      } else if (esOferente) {
        return DICTONARY.ROL.GENERADOR.NOMBRE;
      } else if (esGestor) {
        return DICTONARY.ROL.GESTOR.NOMBRE;
      } else if (esAsesor) {
        return DICTONARY.ROL.ASESOR.NOMBRE;
      } else if (esTransportista) {
        return DICTONARY.ROL.TRANSPORTISTA.NOMBRE;
      }

      // LUEGO SE REVISA POR EMPRESA SI LA SUCURSAL DEL USUARIO LOGUEADO
      // NO PARTICIPA EN LA TRANSACCIÓN

      //   CASO ESPECIAL, SI LA TRANSACCIÓN ES UNA TRANSACCIÓN
      //   INTERNA DE LA EMPRESA (SOLO APLICA PARA ADMINISTRADOR)

      if (isAdmin) {
        const sucursalDemandante = listaSucursalesUsuarioLogueado.find(
          sucursal =>
            sucursal.codigoSucursal === sucursales.receptor.codigoSucursal
        );

        const sucursalOferente = listaSucursalesUsuarioLogueado.find(
          sucursal =>
            sucursal.codigoSucursal === sucursales.generador.codigoSucursal
        );

        // Verifica que ambas sucursales pertenecen a la empresa
        if (sucursalDemandante && sucursalOferente) {
          // El rol del admin depende del estado de la transacción
          if (
            transaccion.ultimaTrasaccion.codigoEstado ===
              DICTONARY.ESTADOS_TRANSACCION[1].CODIGO ||
            transaccion.ultimaTrasaccion.codigoEstado ===
              DICTONARY.ESTADOS_TRANSACCION[3].CODIGO
          ) {
            return DICTONARY.ROL.RECEPTOR.NOMBRE;
          } else if (
            transaccion.ultimaTrasaccion.codigoEstado ===
            DICTONARY.ESTADOS_TRANSACCION[2].CODIGO
          ) {
            return DICTONARY.ROL.GENERADOR.NOMBRE;
          }
        }
      }

      // EMPRESA ES DEMANDANTE
      //Buscar coincidencias en la lista de sucursales del usuario logueado
      const buscarCoincidencias = sucursal => {
        return listaSucursalesUsuarioLogueado.find(
          sucursalUsuario =>
            sucursalUsuario.codigoSucursal === sucursal.codigoSucursal
        );
      };

      //Verificar si la empresa es demandante y si tiene alguna coincidencia
      if (sucursales.receptor && buscarCoincidencias(sucursales.receptor)) {
        return DICTONARY.ROL.RECEPTOR.NOMBRE;
      }

      //Verificar si la empresa es oferente y si tiene alguna coincidencia
      if (sucursales.generador && buscarCoincidencias(sucursales.generador)) {
        return DICTONARY.ROL.GENERADOR.NOMBRE;
      }

      // EMPRESA ES GESTOR
      const sucursalGestor = sucursales.gestor;

      if (
        sucursalGestor &&
        listaSucursalesUsuarioLogueado.find(
          sucursal => sucursal.codigoSucursal === sucursalGestor.codigoSucursal
        )
      ) {
        return DICTONARY.ROL.GESTOR.NOMBRE;
      }

      // EMPRESA ES ASESOR
      // si la sucursal tiene un asesor
      if (
        sucursales.asesor &&
        // y el usuario ha iniciado sesión en una sucursal que tiene el mismo código de sucursal que el asesor
        listaSucursalesUsuarioLogueado.find(
          sucursal =>
            sucursal.codigoSucursal === sucursales.asesor.codigoSucursal
        )
      )
        // entonces el usuario es un asesor para esa sucursal
        return DICTONARY.ROL.ASESOR.NOMBRE;

      // EMPRESA ES TRANSPORTISTA
      if (
        sucursales.transportista &&
        listaSucursalesUsuarioLogueado.some(
          sucursal =>
            sucursal.codigoSucursal === sucursales.transportista.codigoSucursal
        )
      )
        return DICTONARY.ROL.TRANSPORTISTA.NOMBRE;
    } catch (err) {
      AlertaError(
        'Ha ocurrido un error al tratar de determinar el rol del usuario en la transacción.'
      );
      console.error(err);
      return 'error';
    }

    // NI LA EMPRESA NI LA SUCURSAL DEL USUARIO
    // LOGUEADO PARTICIPAN EN LA TRANSACCIÓN?
    return 'none';
  };

  return {
    listaSucursalesUsuarioLogueado,
    listaSalasChat,
    setListaSalasChat,
    transaccionSelected,
    setTransaccionSelected,
    dataEmpresasFiltradas,
    setDataEmpresasFiltradas,
    openModal,
    setOpenModal,
    handleOpenModal,
    handleCloseModal,
    handleClickTerminarYAprobarReceptor,
    handleClickTerminarYAprobarGenerador,
    handleClickTerminarYRechazar,
    handleClickResumenTransaccion,
    handleClickGuardarResiduoDeclarado,
    handleClickSalaChat,
    determinarRolEnTransaccion
  };
};
